import { Wording } from '@/types';

export const LOVE_WORDING_LT: Wording = {
  components_header_media_content: 'Garso įrašai',
  components_header_media_1: 'Meditacijos',
  components_header_media_2: 'Podcast\'as',
  components_header_text1: 'Vadovai',
  components_header_text2: 'Dienoraštis',
  components_header_members: 'nariai',
  hero_text: 'Atraskite meilę per žvaigždes',
  hero_button_text: 'Pradėkite savo kelionę',
  components_ressources_section_title: 'MEILĖ IR ASTROLOGIJA',
  components_ressources_subheader_text: 'Jūsų dangiškasis romantiškos įžvalgos įrankių rinkinys',
  components_ressources_span_text: 'Pasinerkite į mūsų internetinių transliacijų ir straipsnių, kurių centre yra meilė, zodiako ženklų suderinamumas ir kosminis ryšys, visatą. Nesvarbu, ar ieškote sielos draugo aiškumo, ar dekoduojate savo santykių modelius, mūsų ištekliai padės jums giliau suprasti žvaigždes.',
  components_ressources_card_1_title: 'Zodiako meilės pokalbiai',
  components_ressources_card_1_text: 'Naršykite nuoširdžius tinklalaidės epizodus, gilindamiesi į kiekvieno ženklo emocinę kalbą, meilės suderinamumą, aistrą ir asmeninį santykių augimą.',
  components_ressources_card_2_title: 'Meilės dienoraštis',
  components_ressources_card_2_text: 'Skaitykite įžvalgas ir apmąstymus apie tai, kaip kiekvienas ženklas myli, gydo ir jungiasi. Nuo sinatrijos iki planetos romantikos – mūsų tinklaraštis yra jūsų astrologinės meilės vadovas.',
  components_ressources_link: 'Naršyti toliau',
  components_notes_and_google_title_1: 'Romantinė astrologija',
  components_notes_and_google_title_2: 'Meilės įpročiai',
  components_notes_and_google_title_3: 'Klausytojų meilės atspindžiai',
  components_review_google_text: 'Ką sako mūsų klausytojai',
  media_content_section_title: 'LOVE & ZODIAC PODCAST',
  media_content_section_subheader_text: 'Tikras pokalbis apie kosminę romantiką',
  text_media_1: 'Prisijunkite prie gilių, atskleidžiančių epizodų apie astrologines rungtynes, emocinius modelius ir romantišką dinamiką.',
  text_media_2: '',
  media_content_section_button_more: 'Klausyk dabar',
  text2_section_title: 'BLOGAS',
  text2_section_subheader_text: 'Astrologinės meilės istorijos ir įžvalgos',
  text2_section_button_more: 'Įkelti daugiau',
  components_text1_section_title: 'VADOVAI',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: '',
  components_footer_text: 'Leiskite žvaigždėms vadovauti jūsų meilės istorijai',
  components_footer_info: 'Informacija',
  components_footer_registration_number: 'Registracijos numeris',
  components_footer_legal: 'Teisinė',
  components_footer_terms: 'Taisyklės ir sąlygos',
  components_footer_privacy: 'Privatumo politika',
  button_load_more: 'Įkelti daugiau',
  page_media_2_content_hero_text: '',
  page_media_content_menu_antistress: '',
  page_media_content_menu_mindfulness: '',
  page_media_content_menu_energyboost: '',
  page_media_content_menu_mantra: '',
  page_media_1_content_hero_text: 'Meilė ir zodiakas: podcast epizodai',
  page_media_content_menu_compatibility: 'Suderinamumas',
  page_media_content_menu_love: 'Meilė',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Tyrinėkite meilę per astrologiją',
  page_text2_section_title: 'Dienoraštis',
  page_text2_subheader_text: 'Straipsniai',
  enter_email_title: 'Norėdami tęsti, įveskite savo el. pašto adresą',
  enter_email_placeholder_email: 'El. paštas',
  enter_email_button_enter: 'Įeikite',
  components_login_success_text: 'Prisijungimas sėkmingas!',
  components_card_link_media_content: 'Klausyk dabar',
  components_card_link_text2_content: 'Skaityti straipsnius',
  components_card_link_text1_content: '',
  france: 'Prancūzija',
  cyprus: 'Kipras',
  tag_podcast: 'Podcast\'as',
  tag_meditation: 'Meditacija',
  page_media_content_menu_all: 'Visi',
};